import { useEffect } from 'react';

const useLocationChange = (callback) => {
  useEffect(() => {
    const oldPushState = window.history.pushState;
    const oldReplaceState = window.history.replaceState;
    const dispatchEventLocationChange = () => {
      window.dispatchEvent(new Event("locationchange"));
    };
    (() => {
      window.history.pushState = function pushState(...args) {
        const ret = oldPushState.apply(this, args);
        dispatchEventLocationChange();
        return ret;
      };
      window.history.replaceState = function replaceState(...args) {
        const ret = oldReplaceState.apply(this, args);
        dispatchEventLocationChange();
        return ret;
      };
      window.addEventListener("popstate", dispatchEventLocationChange, false);
    })();
    window.addEventListener("locationchange", callback, false);
    return () => {
      window.removeEventListener("locationchange", callback, false);
      window.history.pushState = oldPushState;
      window.history.replaceState = oldReplaceState;
      window.removeEventListener(
        "popstate",
        dispatchEventLocationChange,
        false
      );
    };
  }, []);
};

export { useLocationChange };
